<template>
  <span
    class="badge"
    :style="{ color: 'white', backgroundColor: color }"
  >
    {{ text }}
  </span>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
  },
}
</script>

<style scoped>
.badge {
  text-transform: uppercase;
  padding: 0.3rem 0.5rem;
  font-size: 1.2rem;
  border-radius: 0.4rem;
}
</style>
